import { useQuery } from "@apollo/react-hooks";

import { Instructor } from "@hubcapp/types";

import InstructorTransactionsDataQuery from "../graph-ql/getInstructorTransactionsData.graphql";

const useInstructorTransactionsData = (id?: string) =>
  useQuery<{ instructor: Pick<Instructor, "ledgerItems"> }>(
    InstructorTransactionsDataQuery,
    {
      variables: {
        id,
      },
      skip: !id,
    },
  );

export default useInstructorTransactionsData;
